import { FormControl, InputAdornment, MenuItem, Select } from '@mui/material';
import useMenu from 'hooks/useMenu';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useShowroom } from 'context';

const ShaxmatkaModeSelect = () => {
  const { t } = useTranslation();
  const { hasChild } = useMenu();
  const [{ mode }, dispatch] = useShowroom();
  const view = (code) => hasChild('SHOWROOM', code);

  const options = [
    {
      label: t('shaxmatka.mode.view'),
      code: 'VIEW',
      disabled: false,
    },
    {
      label: t('shaxmatka.mode.edit'),
      code: 'EDIT',
      disabled: !view('EDIT_HOMES'),
    },
    {
      label: t('shaxmatka.mode.priceEdit'),
      code: 'PRICE_EDIT',
      disabled: !view('EDIT_HOMES'),
    },
    {
      label: t('shaxmatka.mode.homeEdit'),
      code: 'PLACE_EDIT',
      disabled: !view('EDIT_HOMES'),
    },
  ];

  return (
    <FormControl
      fullWidth
      color='formColor'
      sx={{ width: '180px', marginRight: 2, marginTop: 0, marginBottom: 0 }}
    >
      <Select
        className='shaxmatka-select-mode'
        labelId='select-mode-label'
        id='select-mode-select'
        onChange={(event) => {
          dispatch({ type: 'setMode', payload: event.target.value });
        }}
        value={mode}
        color='formColor'
        variant='outlined'
        role='presentation'
        MenuProps={{
          id: 'select-mode-select-menu',
          disableScrollLock: true,
          PaperProps: {
            style: {
              maxHeight: 300,
            },
          },
        }}
        readOnly={!view('EDIT_HOMES')}
        disabled={!view('EDIT_HOMES')}
        size='small'
        startAdornment={
          <InputAdornment position='start'>
            {mode == 'VIEW' ? (
              <i className='bi bi-eye adornment-icon view-icon' />
            ) : mode == 'EDIT' ? (
              <i className='bi bi-pencil-square adornment-icon edit-icon' />
            ) : (
              <i className='bi bi-currency-dollar adornment-icon edit-icon' />
            )}
          </InputAdornment>
        }
      >
        {options
          .filter((item) => !item.disabled)
          .map((item, index) => (
            <MenuItem
              value={item.code}
              key={`mode-select-${index + 1}`}
              className='small-size'
            >
              {item.label}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};

export default memo(ShaxmatkaModeSelect);
